<script lang="ts">
  import { GivenAnswer } from "../../models/GivenAnswer"
  import { Question } from "../../models/Question"
  import RadioButtons from "@components/ui/RadioButtons.svelte"

  export let givenAnswer: GivenAnswer
  export let question: Question
</script>

<RadioButtons>
  {#each question.possibleAnswers.items as possibleAnswer}
    <label class="flex items-center">
      <input
        type="checkbox"
        id={`answer-${question.id}`}
        name={`answer-${question.id}`}
        data-role="answer-${question.id}-{possibleAnswer.id}"
        bind:group={givenAnswer.multiChoiceAnswerIds}
        value={possibleAnswer.id}
        class="shrink-0 mr-1"
      />
      {possibleAnswer.name}
    </label>
  {/each}
</RadioButtons>
